import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getTokensCount = reatomAsync(
  async (ctx, { userId }: { userId: string }) => {
    return API.tokenApi
      .apiTokenControllerGetApiTokenCountByUserId(userId)
      .then((response) => response.data);
  },
  "getTokensCountRequest",
).pipe(withDataAtom(0), withIsLoadingAtom());
